import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import { googleTagsInit } from "@utils/googleTagsInit/googleTagsInit";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const targetEnv = process.env.REACT_APP_TARGET_ENVIRONMENT;

if (targetEnv === "prod") {
  googleTagsInit();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
